// extracted by mini-css-extract-plugin
export default {"button":"edit-details-link_button__00e4e"};